// src/supabase/config.ts
import { createClient } from '@supabase/supabase-js'
import { installTenantStamping } from './tenantStamp'
import { resolveAppSchema } from './schema'

// Supabase configuration from environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

console.log('Initializing Supabase client...')

// Schema to read/write. Fails closed: VITE_SUPABASE_DB_SCHEMA must be set to the
// app schema (`pit`). Unset or `public` throws, because on the shared SCR Central
// database `public` is other applications' data. Realtime subscriptions use this
// same constant so they cannot drift from the client's schema.
export const DB_SCHEMA = resolveAppSchema(import.meta.env.VITE_SUPABASE_DB_SCHEMA)

// Create the Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: { schema: DB_SCHEMA as 'public' },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  },
  realtime: {
    params: {
      eventsPerSecond: 2
    }
  }
})

// Stamp tenant_id on every insert/upsert. Done here, on the one exported
// client, so all ~25 write paths in src/ are covered without touching a single
// call site. Only fills tenant_id when absent, and stamps nothing when the
// tenant cannot be resolved — so it can never make a write fail that would
// otherwise have succeeded. See ./tenantStamp.ts for why this exists.
installTenantStamping(supabase)

// Auth state change listener removed - now handled centrally in AuthContext
// This prevents race conditions between multiple listeners

console.log('Supabase setup complete')

export default supabase